
webpack.register(
    'modules/player-comparison/player-comparison',
    function() {
        return import('modules/player-comparison/player-comparison');
    },
    true
);